import { SELLER_REF } from "constants";
import { CAMPAIGN_REF } from "constants";
import { TRACK_TOKEN } from "constants";
import { API_URL } from "constants";
import logger from "utils/logger";

/**
 * Creats a new PaymentIntent / Fetches a new client_secret
 * @param {number} amount - The amount for the PaymentIntent.
 * @param {object} body - The body for the ticket.
 * @param {string} paymentMethod - The payment method for the PaymentIntent.
 * @returns {Promise<object>} - The PaymentIntent. Access the client_secret with `PaymentIntent.client_secret`.
 */
export default async function createPaymentIntent({
  amount,
  body,
  paymentMethod,
}) {
  const sellerRef = window.localStorage.getItem(SELLER_REF);
  const campaignRef = window.localStorage.getItem(CAMPAIGN_REF);
  const trackToken = window.localStorage.getItem(TRACK_TOKEN);
  const apibody = {
    // amount,
    // currency: "eur",
    // isPackage: false,
    paymentMethod,
    ...body,
    "consumerUsername": body.eventBookingPayload.username,
    "consumerFullname": body.eventBookingPayload.fullName,
    "consumerEmail": body.eventBookingPayload.email,
    ...sellerRef !== undefined && sellerRef && sellerRef !== "" ? { sellerReferenceId: sellerRef } : {},
    ...sellerRef && campaignRef && campaignRef !== "" ? { campaignId: campaignRef } : {},
    ...(trackToken && trackToken !== "" ? { trackToken } : {}),
  };
  // Preserve dietary preferences before deleting eventBookingPayload
  if (apibody.eventBookingPayload?.dietaryPreferences?.length) {
    apibody.dietaryPreferences = apibody.eventBookingPayload.dietaryPreferences;
  }
  delete apibody.eventBookingPayload;
  // const res = await fetch(API_URL + "/payments/createStripePaymentIntentUA", {
  const res = await fetch(API_URL + "/payments/orderPlace", {
    method: "POST",
    body: JSON.stringify(apibody),
  });

  const resJson = await res.json();
  logger.log("resJson.data", resJson.data);

  return resJson.statusCode === 200
    ? { error: false ,...resJson.data, client_secret: resJson.data.paymentIntent.client_secret, amountInCents: resJson.data.paymentIntent.amountInCents }
    : { client_secret: "", orderReferenceId: "", error: true , message: resJson.message };
}
